import { useTranslation as useReactI18nextTranslation } from 'react-i18next'
import { SupportedLanguage } from '../config'

// Re-export the useTranslation hook with proper typing
export function useTranslation() {
  const { t, i18n } = useReactI18nextTranslation()

  // Helper function to change language
  const changeLanguage = (language: SupportedLanguage) => {
    return i18n.changeLanguage(language)
  }

  // Get current language
  const currentLanguage = i18n.language as SupportedLanguage

  // Check if language is ready
  const isReady = i18n.isInitialized

  return {
    t,
    i18n,
    changeLanguage,
    currentLanguage,
    isReady,
  }
}

// Export the translation function type for external use
export type TranslationFunction = ReturnType<typeof useTranslation>['t'] 